import { Box, IconButton, Tooltip } from '@mui/material';
import PropTypes from 'prop-types';
import { FC, useState, useEffect } from 'react';
import EditTwoToneIcon from '@mui/icons-material/EditTwoTone';
import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid';
import { useTranslation } from 'react-i18next';
import { OrganizationData } from 'src/modules/Organization/models';
import { Card, Tables } from 'src/shared/components/index';
import { I18N, ROLES } from 'src/shared/constants/constants';
interface RecentOrdersTableProps {
  className?: string;
  handleEditIconClick(row: any): void;
  handleTenantNameClick(row: any): void;
  inputLoginUserRole: string;
  inputOrganizationData: OrganizationData[];
}

const OrganizationTable: FC<RecentOrdersTableProps> = ({
  handleEditIconClick,
  handleTenantNameClick,
  inputOrganizationData,
  inputLoginUserRole
}) => {
  const [orgTableColumns, setOrgTableColumns] = useState([]);
  const handleEditIconClickEvent = (row) => {
    handleEditIconClick(row);
  };

  const handleTenantNameClickEvent = (row) => {
    handleTenantNameClick(row);
  };

  const { t } = useTranslation(I18N.DEFAULT);

  const columns: GridColDef[] = [
    {
      field: ' ',
      headerName: ' ',
      sortable: false,
      type: 'string',
      flex: 0.7
    },
    {
      field: 'code',
      sortable: true,
      headerName: t('code'),
      flex: 7,
      renderCell: (params: GridRenderCellParams<any>) => {
        return (
          <>
            {' '}
            <div
              style={{ cursor: 'pointer' }}
              onClick={() => handleTenantNameClickEvent(params.row)}
            >
              {params.row.code}
            </div>
          </>
        );
      }
    },
    {
      field: 'tenantName',
      sortable: true,
      headerName: t('name'),
      flex: 7,
      renderCell: (params: GridRenderCellParams<any>) => {
        return (
          <>
            {' '}
            <div
              style={{ cursor: 'pointer' }}
              onClick={() => handleTenantNameClickEvent(params.row)}
            >
              {params.row.tenantName}
            </div>
          </>
        );
      }
    },
    {
      field: 'gstNo',
      sortable: true,
      type: 'string',
      headerName: t('GST No'),
      flex: 3,
    },
    {
      field: 'phoneNo',
      type: 'string',
      sortable: true,
      headerName: t('phoneNo'),
      flex: 2,
    }
  ];
  const actionColumn: GridColDef = {
    field: inputLoginUserRole === ROLES.SUPER_ADMIN ? t('actions') : t(''),
    sortable: false,
    width: 100,
    flex: 3,
    renderCell: (params: GridRenderCellParams<any>) => {
      return (
        <>
          <Tooltip title={t('edit')} arrow>
            <IconButton
              aria-label="editOrganization"
              className="RecentOrderEditButton"
              color="inherit"
              size="small"
              onClick={() => handleEditIconClickEvent(params.row)}
            >
              <EditTwoToneIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </>
      );
    }
  };
  useEffect(() => {
    if (inputLoginUserRole === ROLES.SUPER_ADMIN) {
      setOrgTableColumns([...columns, actionColumn]);
    } else {
      setOrgTableColumns(columns);
    }
  }, []);
  return (
    <>
      <Tables
        rows={inputOrganizationData}
        columns={orgTableColumns}
        checkboxSelection={false}
      />
    </>
  );
};

OrganizationTable.propTypes = {
  inputOrganizationData: PropTypes.array.isRequired
};

OrganizationTable.defaultProps = {
  inputOrganizationData: []
};

export default OrganizationTable;
